// @flow
import type { AppStateType } from '../../../../reducers/appstate'
import type { Dispatch } from 'redux'
import { withRouter } from 'next/router'
import { connect } from 'react-redux'
import type { DispatchPropsType, PropsType, FacebookTextType } from './FacebookSignIn'
import FacebookSignIn from './FacebookSignIn'
import { signInWithFacebook } from '../../../../actions/userActions'

type OwnPropsType = {
  type: FacebookTextType,
  disable: boolean,
  isOutlineStyle: boolean,
  socialAuthAgeCheck: (callback: (params?: any) => any) => void,
  isSignUp: boolean
}

const mapStateToProps = (_state: AppStateType, ownProps: OwnPropsType): any => {
  return ({
    type: ownProps.type,
    disable: ownProps.disable,
    socialAuthAgeCheck: ownProps.socialAuthAgeCheck,
    isOutlineStyle: ownProps.isOutlineStyle,
    isSignUp: ownProps.isSignUp
  }: PropsType)
}

const mapDispatchToProps = (dispatch: Dispatch<any>): any => {
  return ({
    signInWithFacebook: (): void => dispatch(signInWithFacebook())
  }: DispatchPropsType)
}

export default withRouter(connect<PropsType & DispatchPropsType, OwnPropsType, _, _, _, _>(mapStateToProps, mapDispatchToProps)(FacebookSignIn))
